import React from "react";
import { Link } from "react-router-dom";
import "../Aboutus/Aboutus.css";
import Text from "./Text";
import Award from "./Award";

const Aboutus = () => {
  return (
    <>
      <Text />
      <div className="about-us">
        <div className="overlay-a">
          <div className="text-container">
            <h1>Precision in Every Package</h1>
            <p>
              We specialize in high-quality packaging solutions tailored for
              orthopedic instruments.
            </p>
            <Link to="/contactus">
              <button className="animated-button">Contact Us</button>
            </Link>
          </div>
        </div>
        <img
          src="/ab.webp" // Replace with your image URL
          alt="About Us Poster"
          className="poster-image"
        />
      </div>
      <Award />
    </>
  );
};

export default Aboutus;
